import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'


function ApplyConfigTemplateModal({ show, handleCancel, handleConfirm, selectedUtgsSignal, configTemplatesSignal, selectedConfigTemplateIdSignal }) {

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Apply Config Template</Modal.Title>
      </Modal.Header>
          <Modal.Body>
              <p>The selected config template will be merged into the configuration settings for the {selectedUtgsSignal.value.length ? selectedUtgsSignal.value.length : 0} selected UTG{selectedUtgsSignal.value.length && selectedUtgsSignal.value.length != 1 ? "s" : ""}.</p>
        <Form.Group className="mb-3" controlId="configTemplateControlInput">
            <Form.Label>Config Template</Form.Label>
            <Form.Select aria-label="Config Template" 
                required
                      value={selectedConfigTemplateIdSignal.value}
                      onChange={(e) => selectedConfigTemplateIdSignal.value = e.target.value}>
                    <option key={-1}></option>
                      {configTemplatesSignal.value.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
            </Form.Select>
            <hr />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
              <Button variant="danger" disabled={selectedConfigTemplateIdSignal.value == -1} onClick={() => handleConfirm()}>Submit</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ApplyConfigTemplateModal;

